import React from 'react';
import { Box } from '@chakra-ui/react';
import TableTemplate from '@components/tableTemplate';
import { useUserManagementFilterStore, useUserManagementStore } from '@pages/UserManagement/helpers/mainState';
import { tableList } from './const';
import './styles.scss';

const Table = () => {
    const { paginationInfo, isLoadingTable, users } = useUserManagementStore();
    const { onChangeUserManagementFilterSelectedStore, page } = useUserManagementFilterStore();
    const handlePageClick = ({ selected }) => onChangeUserManagementFilterSelectedStore({ page: selected + 1 });

    return (
        <Box className="table-user-management__container">
            <TableTemplate
                tableList={tableList}
                data={users}
                dataCount={paginationInfo?.dataCount}
                totalData={paginationInfo?.totalData}
                page={page}
                totalPage={paginationInfo?.totalPage}
                handlePageClick={handlePageClick}
                isPagination={true}
                isDynamicTable={false}
                isLoading={isLoadingTable}
                overflowTable="visible"
            />
        </Box>
    );
};

export default Table;
